import React from 'react';

import {
    Modal,
    Form,
    Input,
    InputNumber,
    Icon,
    Button,
} from 'antd'

import {
    _getUser,
} from '../../services';

import './index.css'

class ApprovalModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: true
        }
    }

    render() {
        return (
            <Modal
                afterClose={()=>{
                    this.setState({
                        renderModal: false,
                        activeEnterprise: false
                    })
                }}
                centered
                footer={null}
                visible={this.props.visible}
                closable
                onCancel={this.closeModal}
            >
                {!this.state.loading && this.renderForm()}
            </Modal>
        )
    }

    componentDidMount() {
        _getUser(this.props.activeEnterprise.applicantId)
        .then(res => {
            this.setState({
                applicant: res.data,
                loading: false,
            })
        })
    }

    closeModal = () => {
        this.props.closeModal()
    }

    renderForm = () => {
        const { getFieldDecorator } = this.props.form;

        const { activeEnterprise } = this.props;

        return (
            <Form 
            className="enterprise-form"
            style={{margin: 16}}
            onSubmit={this.handleSubmit}>
              <Form.Item label="Enterprise Name">
                {getFieldDecorator('companyName', {
                  initialValue: activeEnterprise.companyName,
                  rules: [{ required: true}],
                })(
                  <Input
                    prefix={<Icon type="team" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    placeholder="Company Name"
                  />,
                )}
              </Form.Item>
    
              <Form.Item label="Credit Term Days">
                {getFieldDecorator('creditTermDays', {
                  initialValue: activeEnterprise.creditTermDays,
                  rules: [{ required: true}],
                })(
                  <InputNumber
                    placeholder={30}
                  />,
                )}
              </Form.Item>
              <Form.Item label="Credit Limit">
                {getFieldDecorator('creditLimit', {
                  initialValue: activeEnterprise.creditLimit,
                  rules: [{ required: true}],
                })(
                  <InputNumber
                    placeholder={3000}
                  />,
                )}
              </Form.Item>

              <div className="display-row">
                <p className="display-label">Applicant Name:</p>
                <p className="display-value">{this.state.applicant.details.name}</p>
              </div>

              <div className="display-row">
                <p className="display-label">Applicant Email:</p>
                <p className="display-value">{this.state.applicant.details.email}</p>
              </div>

              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Approve
                </Button>
              </Form.Item>
            </Form>
        )
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {

          if (!err) {

            this.props.approveCreditApplication({
                enterpriseId: this.props.activeEnterprise._id,
                creditLimit: values.creditLimit,
                creditTermDays: values.creditTermDays,
            })
            this.closeModal()
          }

        })

    }
}

export default Form.create()(ApprovalModal)


// WEBPACK FOOTER //
// ./src/components/credit-approval/approval-modal.js